<template>
  <div ref="ticketsprodcuts_SalesReceipt" class="d-none">
    <div v-html="EjsData"></div>
    <!-- <table style="width: 100%;max-width: 320px; font-size: 12px;">
      <thead>
        <tr>
          <th>
            <p style="margin:0;">{{bookingDetails.cine_name}}</p>
            <p style="margin:3px;">{{bookingDetails.cine_phone}}</p>
          </th>
        </tr>

        <tr>
          <th colspan="3">
            <p style="font-size: 10px;margin:0;padding-bottom: 10px;">Sales Receipt</p>
            <span>{{ currentDate }}</span>
          </th>
          <th colspan="2" style="text-align:right;padding-bottom: 10px;">
            <p style="font-size: 10px;margin:0;">Transaction No:</p>
            <span>{{ bookingDetails.sb_booking_code }}</span>
          </th>
        </tr>

        <tr>
          <td colspan="5" style="padding-top:10px;border-bottom:1px dashed #404040;"></td>
        </tr>

        <tr>
          <th style="width: 45%;text-align:left;">DESCRIPTION</th>
          <th style="width 10%;text-align:center;">QTY</th>
          <th style="width: 15%;text-align:center;">PRICE</th>
          <th style="width: 15%;text-align:center;">TAX</th>
          <th style="width: 15%;text-align:right;">TOTAL</th>
        </tr>

        <tr>
          <td colspan="5" style="border-top:1px dashed #404040;"></td>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td colspan="5">
            <p style="margin:15px 0 5px 0;font-size:10px;color:#484848;">BOOKING SUMMARY:</p>
          </td>
        </tr>

        <tr>
          <td style="text-aling:left;">
            <p
              style="margin: 1px 0;"
            >{{ bookingDetails.movie_title }}-{{bookingDetails.mf_name}}-{{bookingDetails.lang_name}}</p>

            <p
              style="margin:1px 0;"
            >{{ bookingDetails.og_show_date | dateparse }} {{ bookingDetails.og_show_time | timeparseAmPm }}</p>

            <p
              :key="seatTypeIndex"
              style="margin:2px 0;"
              v-for="(seatType, seatTypeIndex) in bookingDetails.uniqueSeatTypes"
            >
              ({{bookingDetails.screen_name}}:
              <span>{{seatType}} - {{bookingDetails.seats}}</span>
              <span v-if="seatTypeIndex + 1 < bookingDetails.uniqueSeatTypes.length">,</span>)
            </p>
          </td>

          <td
            style="text-align:center;vertical-align: top;"
          >{{ bookingDetails["seats_types"] ? bookingDetails["seats_types"].length : '' }}</td>

          <td style="text-align:center;vertical-align: top;">{{ netAmount.toFixed(2) }}</td>
          <td style="text-align:center;vertical-align: top;">{{ getTaxAmount.toFixed(2) }}</td>
          <td style="text-align:right;vertical-align: top;">{{ totalAmount }}</td>
        </tr>

        <tr v-if="Items && Items.length > 0">
          <td colspan="5">
            <p style="margin:15px 0 5px 0;font-size:10px;color:#484848;">PRODUCTS:</p>
          </td>
        </tr>

        <tr v-if="Items && Items.length > 0" v-for="(item, itemIndex) in Items" :key="itemIndex">
          <td style="text-align:left;">
            <p style="margin: 1px 0;">{{ item.item_name || item.recipe_name }}</p>
          </td>

          <td style="text-align:center;">
            <p style="margin: 1px 0;">{{ item.quantity }}</p>
          </td>

          <td style="text-align:center;">
            <p style="margin: 1px 0;">{{ item.fp_amount.toFixed(2) }}</p>
          </td>

          <td style="text-align:center;">
            <p style="margin: 1px 0;">{{ getTotalFnBTax.toFixed(2) }}</p>
          </td>

          <td style="text-align:center;">
            <p style="margin: 1px 0;">{{ FnBItemsTotalPrice.toFixed(2) }}</p>
          </td>
        </tr>

        <tr>
          <td colspan="5" style="padding-top: 3px;border-bottom:1px dashed #404040;"></td>
        </tr>

        <tr>
          <td colspan="2" style="text-align:left;">
            <p style="margin: 2px 0;font-weight: bold;">Products Total:</p>
          </td>

          <td colspan="3" style="text-align: right;">
            <p
              style="margin: 2px 0;font-weight: bold;"
            >{{ getcurrency }} {{ (totalAmount + FnBItemsTotalPrice).toFixed(2) }}</p>
          </td>
        </tr>

        <tr>
          <td colspan="5">
            <p style="margin:15px 0 5px 0;font-size:10px;color:#484848;">PAYMENT MODES:</p>
          </td>
        </tr>

        <tr
          v-if="getSelectedOffer && getSelectedOffer.offer_print_on_ticket == 'Y' || offerFor == 'vouchers'"
          style="border-bottom: 1px dashed #000000"
        >
          <td colspan="2" style="text-align: left;">
            <div style="font-weight: bold;">Discount</div>
            {{ getSelectedOffer.offer_title || getSelectedOffer.voucher_title }}
          </td>
          <td
            colspan="3"
            style="text-align: right; vertical-align: bottom"
          >{{ getcurrency }} {{ offerPrice }}</td>
        </tr>

        <tr>
          <td colspan="2" style="text-align:left;">{{ paymentDetails.pm_payment_mode }}</td>
          <td colspan="3" style="text-align:right;">{{ getcurrency }} {{ totalAmount.toFixed(2) }}</td>
        </tr>

        <tr>
          <td colspan="5" style="padding-top: 15px;border-bottom:1px dashed #404040;"></td>
        </tr>

        <tr>
          <td colspan="1" style="text-align:left;font-weight:bold;">NET PRICE</td>
          <td colspan="2" style="text-align:center;font-weight:bold;">TAX</td>
          <td colspan="2" style="text-align:right;font-weight:bold;">AMOUNT</td>
        </tr>

        <tr>
          <td colspan="5" style="border-top:1px dashed #404040;"></td>
        </tr>
        <tr>
          <td colspan="1" style="text-align:left;">
            <p style="margin: 2px  0;">{{ (netAmount + FnbNetAmount).toFixed(2) }}</p>
          </td>
          <td colspan="2" style="text-align:center;">
            <p style="margin:2px 0;">{{ (getTaxAmount + getTotalFnBTax).toFixed(2) }}</p>
          </td>
          <td colspan="2" style="text-align:right;">
            <p
              style="margin:2px 0;"
            >{{ getcurrency }} {{ (totalAmount + FnBItemsTotalPrice).toFixed(2) }}</p>
          </td>
        </tr>

        <tr>
          <td colspan="5">
            <p style="margin: 15px 0 0 0;;">Sold By: {{ name }}</p>
            <p
              style="margin: 3px 0;"
            >Sold on: {{ hardwarename && hardwarename.length > 0 ? hardwarename : '-' }}</p>
          </td>
        </tr>
      </tbody>
    </table>-->
  </div>
</template>

<script>
import Printd from "printd";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import PosService from "@/services/PosService";
import moment from "moment";
import { EventBus } from "@/main";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      currentDate: "",
      name: "",
      EjsData: null
    };
  },
  props: {
    printText: {
      type: String,
      default: "Print"
    },
    onClickHandler: {
      type: Function
    },
    itemsList: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String,
      default: ""
    },
    subTotal: {
      type: Number,
      default: null
    },
    total: {
      type: Number,
      default: null
    },
    taxes: {
      type: Array,
      default: () => {
        return [];
      }
    },
    taxesTotal: {
      type: Number,
      default: null
    },
    onNumberSubmit: {
      type: Function
    },
    onPrintCall: {
      type: Function
    }
  },
  computed: {
    getcurrency() {
      return this.$store.getters.GET_CURRENCY;
    },
    hardwarename() {
      return this.$store.getters.gethardwarename;
    },
    paymentDetails() {
      return this.$store.getters.selectedPaymentMode;
    },
    netAmount() {
      return this.$store.getters.NET_AMOUNT;
    },
    AdditionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    getTaxAmount() {
      let TaxValue = null;
      if (this.AdditionalCharges && this.AdditionalCharges.length > 0) {
        this.AdditionalCharges.forEach(e => {
          TaxValue += e.sp_value;
        });
        return TaxValue;
      } else {
        return (TaxValue = 0.0);
      }
    },
    getTotal() {
      let Total = null;

      Total = this.netAmount + this.getTaxAmount;
      return Total;
    },
    offerFor() {
      return this.$store.getters.getOfferFor;
    },
    getSelectedOffer() {
      return this.$store.getters.getSelectedOffer;
    },
    offerPrice() {
      return this.$store.getters.getOfferPrice
        ? parseFloat(this.$store.getters.getOfferPrice).toFixed(2)
        : 0;
    },
    fnbtotalvalue() {
      return this.$store.getters.FnBTotalValue;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    Items() {
      return this.itemsList;
    },
    Currency() {
      return this.currency;
    },
    SubTotal() {
      return this.subTotal ? this.subTotal : null;
    },
    Total() {
      return this.subTotal !== null && this.taxesTotal !== null
        ? this.subTotal + this.taxesTotal
        : null;
    },
    Taxes() {
      return this.taxes;
    },
    getTotalFnBTax() {
      let taxes = null;

      if (this.Taxess && this.Taxes.length > 0) {
        this.Taxes.forEach(e => {
          taxes += e.totalTax;
        });
        return taxes;
      } else {
        return (taxes = 0.0);
      }
    },
    FnbNetAmount() {
      let fnbamount = null;

      if (this.Items && this.Items.length > 0) {
        this.Items.forEach(e => {
          fnbamount += e.fp_amount;
        });
        return fnbamount;
      } else {
        return (fnbamount = 0.0);
      }
    },
    TaxesTotal() {
      return this.taxesTotal ? this.taxesTotal : null;
    },
    totalAmount() {
      return this.$store.getters.TOTAL_AMOUNT;
    },
    ...mapGetters([
      "TOTAL_AMOUNT",
      "isBoxofficeflag",
      "IDforBoxOfficeEjs",
      "IDforFnBEjs"
    ]),
    ...mapState({
      FnBItemsTotalPrice: state =>
        state.FnBStore.selectedFnBItemsTotalPrice +
        state.FnBStore.totalAdditionalTaxes
    })
  },
  mounted() {
    this.currentDate = moment().format("DD/MM/YY HH:mm");
    this.name = this.secureStore.get("USINFO").first_name;

    EventBus.$on("printTPReceipt", () => {
      // this.print();
      this.GetEjsTicket();
    });
  },
  beforeDestroy() {
    //after called $on event destroy that event to do not call function multiple times
    EventBus.$off("printTPReceipt");
  },
  methods: {
    GetEjsTicket: function() {
      let loader = this.$loading.show();
      if (!("ft_id" in this.IDforFnBEjs)) {
        this.IDforFnBEjs.ft_id = 0;
      }

      PosService.GetReceiptEjs(
        this.IDforBoxOfficeEjs.sb_id,
        this.IDforFnBEjs.ft_id,
        this.IDforBoxOfficeEjs.cinema_id,
        "BoxOfficeFnBReceipt"
      )
        .then(response => {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            this.print();
          });
        })
        .catch(this._CatchError);
      // .finally(() => {
      //   setTimeout(() => loader.hide(), 1000);
      // });
    },
    print: function() {
      const p = new Printd();
      if (this.$refs.ticketsprodcuts_SalesReceipt) {
        p.print(this.$refs.ticketsprodcuts_SalesReceipt, []);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/ReceiptTemplates/Tickets_Products_sales_receipt.vue